export default __webpack_public_path__ + "static/elevate_concept-3c3a09ed55210a82b31887daa824e197.webp";